var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.25C11.0716 3.25 9.18657 3.82177 7.5832 4.89312C5.97982 5.96446 4.73014 7.4872 3.99219 9.26878C3.25423 11.0504 3.06114 13.0108 3.43735 14.9021C3.81355 16.7934 4.74215 18.5307 6.10571 19.8942C7.46928 21.2578 9.20656 22.1864 11.0979 22.5626C12.9892 22.9389 14.9496 22.7458 16.7312 22.0078C18.5128 21.2699 20.0355 20.0201 21.1068 18.4168C22.1782 16.8134 22.75 14.9283 22.75 12.9999C22.75 10.4141 21.7228 7.93418 19.8943 6.1057C18.0658 4.27722 15.5858 3.25 13 3.25Z",
    fill: "#351083"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41675 13H8.66675L10.2917 9.75L13.5417 16.25L15.7084 11.9167L16.2501 13H20.5834",
    stroke: "white",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveAnalysis);
export default __webpack_public_path__ + "static/media/active-analysis.4695ea13e933d27589dd4e539aa24f12.svg";
export { ForwardRef as ReactComponent };